<div class="hello-band py-4">
	<div class="container">
		<div class="row">
			 <div class="col-12 pt-1">
				<h1>{{page['title']}}</h1>			 
			</div>
		</div>
	</div>
</div>
<div class="container py-5" [innerHTML]="text(page['content'])">
	
</div>